<app-modal #modalComponent>
  
  <section #scrollContainer class="modal-content overflow-y-auto max-h-[80vh]">
    <ng-container *ngIf="type === 'politics'">
      <section class="flex flex-col justify-center align-center p-4">
        <div [innerHtml]="processHTML(privacy)"
          class="w-full max-w-screen-lg flex flex-col px-10 xs:px-14 lg:px-0 mx-auto footer-modal-enlace">
        </div>
        <button (click)="close()"
          class="whitespace-nowrap bg-principal border border-principal text-center py-2 px-5 text-white hover:bg-principal-hover hover:text-white hover:border-principal-medio focus:bg-principal-hover focus:text-white rounded">
          Cerrar
        </button>
      </section>
    </ng-container>

    <ng-container *ngIf="type === 'returs-politics'">
      <section class="flex flex-col justify-center align-center p-4 flex-1">
        <div [innerHtml]="processHTML(returnPolicy)"
          class="w-full max-w-screen-lg flex flex-col px-10 xs:px-14 lg:px-0 mx-auto">
        </div>
        <button (click)="close()"
          class=" whitespace-nowrap bg-principal border border-principal text-center py-2 px-5 text-white hover:bg-principal-hover hover:text-white hover:border-principal-medio focus:bg-principal-hover focus:text-white rounded">
          Cerrar
        </button>
      </section>
    </ng-container>

    <ng-container *ngIf="type === 'shipping-policy'">
      <section class="flex flex-col justify-center align-center p-4 flex-1">
        <div [innerHtml]="processHTML(shippingPolicy)"
          class="w-full max-w-screen-lg flex flex-col px-10 xs:px-14 lg:px-0 mx-auto">
        </div>
        <button (click)="close()"
          class="whitespace-nowrap bg-principal border border-principal text-center py-2 px-5 text-white hover:bg-principal-hover hover:text-white hover:border-principal-medio focus:bg-principal-hover focus:text-white rounded">
          Cerrar
        </button>
      </section>
    </ng-container>


    <ng-container *ngIf="type === 'subscription-policy'">
      <section class="flex flex-col justify-center align-center p-4 flex-1 mt-12">
        <div [innerHtml]="processHTML(subscriptionPolicy)"
          class="w-full max-w-screen-lg flex flex-col px-10 xs:px-14 lg:px-0 mx-auto">
        </div>
        <button (click)="close()"
          class="bottom-0 whitespace-nowrap bg-principal border border-principal text-center py-2 px-5 text-white hover:bg-principal-hover hover:text-white hover:border-principal-medio focus:bg-principal-hover focus:text-white rounded">
          Cerrar
        </button>
      </section>
    </ng-container>


    <ng-container *ngIf="type === 'about'">
      <section class="relative overflow-hidden border-b border-gris-claro md:pb-24 lg:pb-64">
        <div [innerHtml]="processHTML(privacy)" class="w-full max-w-screen-lg px-10 lg:px-0 mt-10 mx-auto font-poppins">
        </div>

        <button (click)="close()"
          class="whitespace-nowrap bg-principal border border-principal text-center py-2 px-5 text-white hover:bg-principal-hover hover:text-white hover:border-principal-medio focus:bg-principal-hover focus:text-white rounded">
          Cerrar
        </button>
      </section>
    </ng-container>

    <ng-container *ngIf="type === 'terms'">
      <section class="flex flex-col justify-center align-center gap-4 w-full max-w-screen-lg p-4">
        <div [innerHtml]="processHTML(terms)" (click)="handleButtonClick($event)"
          class="w-full max-w-screen-lg flex flex-col px-10 xs:px-14 lg:px-0 mx-auto">
        </div>
        <button (click)="close()"
          class="whitespace-nowrap bg-principal border border-principal text-center py-2 px-5 text-white hover:bg-principal-hover hover:text-white hover:border-principal-medio focus:bg-principal-hover focus:text-white rounded">
          Cerrar
        </button>
      </section>
    </ng-container>
  </section>
</app-modal>

<ng-template #toolbar> </ng-template>